module.exports = __webpack_public_path__ + "static/media/comment-dollar.75b09364.svg";